import React from "react";

// Master on/off switch — set to false to instantly disable all ads site-wide (e.g. before AdSense review)
export const ADS_ENABLED = true;

export default function AdBanner({ adKey, width, height }) {
  if (!ADS_ENABLED) return null;

  const scale = width > 375 ? +(375 / width).toFixed(3) : 1;
  const scaledHeight = Math.round(height * scale);
  const cls = "ad-" + adKey;

  const srcDoc = `
    <html>
      <body style="margin:0; padding:0; display:flex; align-items:center; justify-content:center; background:transparent;">
        <script>
          atOptions = {
            'key': '${adKey}',
            'format': 'iframe',
            'height': ${height},
            'width': ${width},
            'params': {}
          };
        </script>
        <script src="https://www.highrevenueformat.com/${adKey}/invoke.js"></script>
      </body>
    </html>
  `;

  return (
    <>
      <style>{`
        .${cls}-wrap {
          width: ${width}px;
          height: ${height}px;
          max-width: 100%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .${cls}-inner {
          width: ${width}px;
          height: ${height}px;
          flex-shrink: 0;
        }
        @media (max-width: 480px) {
          .${cls}-wrap {
            height: ${scaledHeight}px;
          }
          .${cls}-inner {
            transform: scale(${scale});
            transform-origin: center;
          }
        }
      `}</style>
      <div className={cls + "-wrap"}>
        <div className={cls + "-inner"}>
          <iframe
            title={"ad-" + adKey}
            srcDoc={srcDoc}
            width={width}
            height={height}
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
          />
        </div>
      </div>
    </>
  );
}